import React from 'react'

function Automation() {
  return (
    <div>
      
    </div>
  )
}

export default Automation
